<template>
  <ScreenDialog ref="refPromptDialog" class="prompt-dialog-wrapper">
    <div class="prompt-dialog-container" v-stat.brow="{
      tag: 'scangift-module.prompt-dialog_brow|一键领取弹窗曝光',
      ext: biCommonExt,
    }">
      <img :src="promptDialogPic" alt="" class="dialog-bg" />
      <slot />
      <div class="button-container">
        <FitButton @click="onClickDialogBtn" v-stat.brow="{
          tag: 'scangift-module.prompt-dialog_click|一键领取弹窗按钮点击',
          ext: biCommonExt,
        }">
          ></FitButton>
      </div>
    </div>
  </ScreenDialog>
</template>

<script lang="ts">
import { ScreenDialog, FitButton } from '@tencent/wphk-ui';
import { defineComponent, onBeforeMount, ref, Ref } from 'vue-demi';
export default defineComponent({
  name: 'PromptDialog',
  components: {
    ScreenDialog,
    FitButton,
  },
  props: {
    promptDialogPic: String,
    onClickPromptDialogBtn: {
      type: Function,
      required: true,
    },
    biCommonExt: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const refPromptDialog: Ref<InstanceType<typeof ScreenDialog> | null> = ref(null);
    const showDialog = () => {
      refPromptDialog.value?.show();
    };
    const onClickDialogBtn = async () => {
      await props.onClickPromptDialogBtn();
      refPromptDialog.value?.hide();
    };
    const preFetchImg = () => {
      if (props.promptDialogPic) {
        const img = new Image();
        img.src = props.promptDialogPic ;
      }
    };
    onBeforeMount(() => {
      preFetchImg();
    });

    return {
      refPromptDialog,
      showDialog,
      onClickDialogBtn,
    };
  },
});
</script>

<style scoped lang="less">
@import (reference) "../less/main.less";

.prompt-dialog-wrapper {

  .prompt-dialog-container {
    position: relative;

    .dialog-bg {
      width: 670 / @rem;
      user-select: none;
    }

    .button-container {
      position: absolute;
      bottom: 56 / @rem;
      left: 50%;
      transform: translateX(-50%);
      opacity: 0;
      width: 368 / @rem;
      height: 80 / @rem;
    }
  }

}
</style>
